import type { AgentComponentToolOption } from '@reach/shared-types/agent-components';
import { toolLabel, toolRequestLabel } from './tool-option-labels';

interface ToolOptionRowProps {
  tool: AgentComponentToolOption;
  selected: boolean;
  onToggle: () => void;
}

const toolUsageLabel = (componentCount: number): string => {
  const toolIsUnused = componentCount === 0;
  const toolIsUsedOnce = componentCount === 1;
  if (toolIsUnused) {
    return 'Not used yet';
  }
  return toolIsUsedOnce ? 'Used in 1 component' : `Used in ${componentCount} components`;
};

export const ToolOptionRow = ({ tool, selected, onToggle }: ToolOptionRowProps) => {
  const name = toolLabel(tool.displayName);
  const details = `${toolRequestLabel(tool)} · ${toolUsageLabel(tool.componentCount)}`;

  return (
    <li>
      <label>
        <input type="checkbox" checked={selected} onChange={onToggle} />
        <strong>{name}</strong>
        <span>{details}</span>
      </label>
    </li>
  );
};
